const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowMissedDelivery', ['ShopperService','MissedDeliveryService', 'GoogleCaptchaService', 'SettingsService', '$timeout', require('./misseddelivery-directives.js')]);
wowApp.service('MissedDeliveryService', ['ProxyService', '$http', require('./misseddelivery-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/misseddelivery/index.js
 **/